import { useRecoilState } from 'recoil';
import { playerCareersState } from '../atoms/playerCareersState';
import { getPlayerCareers } from '../../services/server/application/playerCareers';
import { FirebaseUser } from '../../../firebase';
import { PlayerId } from '../../types/player';


export const useAddPlayerCareers = () => {

  const [playerCareers, setPlayerCareers] = useRecoilState(playerCareersState);


  const addPlayerCareers = async (playerIds: PlayerId[], currentUser: FirebaseUser): Promise<void> => {
    const playerIdsToFetch = playerIds.filter(playerId => !isNaN(Number(playerId)) && !playerCareers[Number(playerId)]).map(playerId => Number(playerId));
    if (playerIdsToFetch.length > 0) {
      const newPlayerCareers = await getPlayerCareers(playerIdsToFetch, currentUser);

      if (newPlayerCareers) {
        setPlayerCareers(currentPlayerCareers => ({
          ...currentPlayerCareers,
          ...newPlayerCareers
        }));
      }
    }
  };


  return addPlayerCareers;
};
